//
import { mapActions } from "vuex"
import { ModelForm } from "@/components/reusable_components/next"
import Translator from "@/services/translator"

//
import RoleModel from "@/models/Role"
import fields from "./fields"

//
export default {
    name: "role-create",
    components: {
        "model-form": ModelForm,
    },
    computed: {

        /**
         * 
         */
        formProps () {
            return {
                fields,
            }
        },
    },
    data () {
        return {
            formData: {},
        }
    },
    methods: {

        //
        ...mapActions( "MenuesModule", {
            setAppToolbarTitle: "setAppToolbarTitle",
        }),

        /**
         * 
         */
        create ( model ) {
            model.toCreate().save().then( this.success ).then( this.redirect ).catch( this.error ).then( this.$refs.form.setWait )
        },

        /**
         * 
         */
        error ( error ) {
            this.$toast.error( Translator( RoleModel, error.response.data ) )
        },

        /**
         * 
         */
        redirect () {
            this.$router.push({ name: "role-list" })
        },

        /**
         * 
         */
        reset () {
            this.formData = new RoleModel()
        },

        /**
         *
         */
        showSnackbar ( type, title, message ) {
            this.initSnackbar( this.fillSnack( type, title, message ) )
        },

        /**
         * 
         */
        submit () {
            this.$refs.form.setWait( true ).then( this.create )
        },

        /**
         * 
         */
        success () {
            this.$toast.success( "Rol agregado." )
        },
    },
    beforeMount () {
        this.setAppToolbarTitle({ title: "Crear rol" })
    },
    mounted () {
        this.reset()
    }
}